import { Component, OnInit } from "@angular/core";
import { StaffApiService } from "./core/api/services";
import { Router } from "@angular/router";
import { AuthService } from "./auth/auth.service";
import { Permissions } from "./core/api/models";
import { AlertService } from "./shared/services/alert.service";
@Component({
  selector: 'app-select-patient',
  templateUrl: './select-patient.component.html',
  standalone: false,
})
export class SelectPatientComponent implements OnInit {

  selectedPatient: { ID: number | undefined, FullName: string } | null = null;
  patientID: number | null = null;
  loading: boolean = true;
  patientOptions: { ID: number | undefined, FullName: string, searchString: string }[] = [];
  constructor(
    private staffApiService: StaffApiService,
    private router: Router,
    private authService: AuthService,
    private alertService: AlertService
  ) {


  }

  ngOnInit(): void {
    if (!this.patientOptions || this.patientOptions.length === 0) {
      this.authService.getMyPatients().subscribe((patients) => {
        if (patients) {
          this.patientOptions = patients.map(patient => ({
            ID: patient.ID,
            FullName: `${patient.FirstName} ${patient.LastName}`,
            searchString: `${patient.FirstName} ${patient.LastName} ${patient.PreferredName ?? ''} ${patient.FirstName?.toLowerCase().substr(0, 3)}${patient.LastName?.toLowerCase().substr(0, 3)}`.toLowerCase()
          }));
        }
        this.loading = false;
      },
        (error) => {
          this.loading = false;
          this.alertService.error('Error loading patients: ' + error.message);
        }
      );
    } else {

      this.loading = false;
    }
  }

  changedPatient(event: { originalEvent: Event, value: number }) {
    const newPatientIDSelected = event.value;
    this.selectedPatient = this.patientOptions?.find(patient => patient.ID === newPatientIDSelected) ?? null;

    if (this.authService.userInfo?.Permissions?.includes(Permissions.SparkApp_Supervisor)) {
      this.router.navigate(['/supervisor/' + newPatientIDSelected + '/overview']);
    } else {
      this.router.navigate(['/staff/' + newPatientIDSelected + '/sessions']);
    }


  }

  goToOfflineData() {
    this.router.navigate(['/offline/patients']);
  }

}
